<template>
  <div class="mb-3">
    <ul class="nav nav-tabs nav-fill" role="tablist">
      <li
        v-for="(report, index) in normalizedReports"
        :key="report.onid || index"
        class="nav-item"
        role="presentation"
      >
        <button
          type="button"
          class="nav-link d-flex align-items-center justify-content-center gap-2"
          :class="{ active: index === (selectedIndex ?? 0) }"
          @click="selectReport(index)"
          :id="`tab-${index}`"
          role="tab"
          :aria-controls="`panel-${index}`"
          :aria-selected="index === (selectedIndex ?? 0)"
        >
          <span class="fw-semibold">Report {{ index + 1 }}</span>
          <span v-if="isCurrentUser(index)" class="badge bg-primary">You</span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SubmissionTabs",
  props: {
    reports: {
      type: Array,
      default: () => []
    },
    selectedIndex: {
      type: Number,
      default: null,
      validator: (value) =>
        value === null || (typeof value === "number" && value >= 0)
    },
    currentUserReportIndex: {
      type: Number,
      default: -1
    }
  },
  emits: ["update:selectedIndex"],
  computed: {
    normalizedReports() {
      return this.reports.filter((report) => !!report?.onid);
    }
  },
  watch: {
    reports: {
      deep: true,
      immediate: true,
      handler() {
        const validReports = this.normalizedReports;

        if (!validReports.length) {
          this.$emit("update:selectedIndex", null);
          return;
        }

        // Validate selectedIndex is within bounds, or set to 0 if null
        if (this.selectedIndex === null) {
          this.$emit("update:selectedIndex", 0);
        } else if (
          this.selectedIndex < 0 ||
          this.selectedIndex >= validReports.length
        ) {
          this.$emit("update:selectedIndex", 0);
        }
      }
    },
    selectedIndex: {
      handler(newIndex) {
        const validReports = this.normalizedReports;
        // Ensure index is within bounds, or set to null if no reports
        if (validReports.length === 0) {
          this.$emit("update:selectedIndex", null);
        } else if (
          newIndex !== null &&
          (newIndex < 0 || newIndex >= validReports.length)
        ) {
          this.$emit("update:selectedIndex", 0);
        }
      }
    }
  },
  methods: {
    selectReport(index) {
      const currentIndex = this.selectedIndex ?? 0;
      if (currentIndex === index) return;
      const validReports = this.normalizedReports;
      if (index >= 0 && index < validReports.length) {
        this.$emit("update:selectedIndex", index);
      }
    },
    isCurrentUser(index) {
      return (
        this.currentUserReportIndex >= 0 &&
        index === this.currentUserReportIndex
      );
    }
  }
};
</script>
